/**
 * Created by qlong on 9/16/2016.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux'
import { NotificationContainer,NotificationManager } from 'react-notifications'
import { setColor, deleteColor, addColorSet, popColorSet, addVisibleIndexes, removeVisibleIndexes } from '../actions/filterGridAction'
import Grid from '../components/Grid'
import Helper from '../Helper'

@connect((store) => {
    return{
        filterGrid: store.filterGrid,
        filteredLineChart: store.filteredLineChart,
        fileData: store.fileData,
    }
})
export default class FilterGrid extends Component{
    onGridToggle(evt) {
        const { visibleIndexes, colorSet, colorSetStatic, colors } = this.props.filterGrid
        const { chart } = this.props.filteredLineChart
        const { chartData } = this.props.fileData
        var index = parseInt(evt.target.getAttribute('data-id'));
        if (colorSet.length == 0 && !(index in colors)) {
            NotificationManager.error('Only 5 series can be displayed at a time. Please unselect series before ' +
                'selecting new ones.', 'Error: Too many series displayed', 3000);
            evt.target.checked = false
            return
        }

        // Get the color from the toggle
        if (visibleIndexes.includes(index)) {
            // Removes it from the visible series
            this.props.dispatch(removeVisibleIndexes(index))

            if (colorSetStatic.includes(colors[index])){ //Unselect series manually selected
                // Retrieve the series color and put it back in the available list
                this.props.dispatch(addColorSet(colors[index]))
                Helper.updateLineChart({index:index,action:"delete",redraw:true,chart:chart})
                this.props.dispatch(deleteColor(index))

            } else { //Unselect series selected by select category
                Helper.updateLineChart({index:index,action:"hide", redraw:true,chart:chart})
            }

        } else {
            // Add it to visible series
            this.props.dispatch(addVisibleIndexes(index))

            if (!(chart.get(index) == undefined)){ // Select series which included in one of the selected category but hided
                Helper.updateLineChart({index:index,action:"show", redraw:true,chart:chart})

            } else { //Manually select series which not existed
                //pop color set
                this.props.dispatch(popColorSet())
                // create series data and add it to the chart
                Helper.updateLineChart({index:index,action:"add",color: colorSet[0], redraw:true,chart:chart,chartData:chartData})
                this.props.dispatch(setColor(index,colorSet[0]))
            }
        }
    }


    updateGridColor(){
        // Call the update color on the grid
        // We have to get to the wrapped instance because of Dimensions()
        this.refs.grid.refs.wrappedInstance.updateColors(this.props.filterGrid.colors)
    }

    render(){
        if (this.props.filterGrid.filterGridData != null && this.props.filterGrid.filterGridData.length > 0) {
            return(
                <div className="filteredGrid">
                    <Grid ref="grid" filters={this.props.filterGrid.filterGridData} visibleIndexes={this.props.filterGrid.visibleIndexes}
                          onToggle={this.onGridToggle.bind(this)} updateGridColor={this.updateGridColor.bind(this)} />
                    <NotificationContainer/>
                </div>
            )
        } else {
            return (<div></div>)
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/containers/FilterGrid.js
 **/